module.exports = __webpack_public_path__ + "img/10_85.32a06686.png";